
    import { defineComponent } from 'vue';
    export default defineComponent({
        data() {
            return {
                dayjs: ((this.$parent) as any).dayjs as any,
                secondsrestants: 0,
                duree:"",
                procinter:null as any
            }
        },
        props: {
            datefin: Date,
            expiredesc:String
        },
        mounted() {
            let self = this;
            self.CalcSeconds();
            self.procinter=setInterval(() => { self.CalcSeconds(); }, 1000);
        },
       
        methods: {
            CalcSeconds() {
                let duree: number = 0;
                if (this.datefin != null && Date.now() < this.datefin.getTime())
                    duree = Math.ceil((this.datefin.getTime() - Date.now()) / 1000);
                else
                    clearInterval(this.procinter);
                this.secondsrestants = duree;
                this.duree = this.dayjs.duration(this.secondsrestants, 'seconds').humanize();
            }
        }
    });
